import { render, staticRenderFns } from "./StorageSpaceCards.vue?vue&type=template&id=6b3eb80c&"
import script from "./StorageSpaceCards.vue?vue&type=script&lang=js&"
export * from "./StorageSpaceCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports